import { RowProps } from './row.d';
import { StyledRowComponent } from './row.styles';

export const Row = (props: RowProps) => <StyledRowComponent {...props} />;
